import React from 'react';
import PropTypes from 'prop-types';
import { LuChevronUp, LuChevronDown } from 'react-icons/lu';
import { VertDropdown } from '@vertem-core/vertice-ds';
import { Link } from 'react-router-dom';

import isExternalLink from 'Utils/isExternalLink';
import generateUUID from 'Utils/generateUUID';
import Icon from '../Icons/Icon';

const createLink = ({ label, href }) => {
  if (isExternalLink(href)) {
    return <a data-label={label} href={href}>{label}</a>;
  }
  return (
    <Link data-label={label} to={href}>
      {label}
    </Link>
  );
};

const standardizeData = (pureItems) => {
  return pureItems.map((item) => ({
    ...item,
    'data-label': item.label,
    label: item.href ? createLink(item) : item.label,
  }));
};

const Dropdown = ({ ...props }) => {
  const itemsWithLabels = standardizeData(props.items);
  const attributesDropdown = {
    ...props,
    id: props.id || generateUUID(),
    items: itemsWithLabels,
    className: props.className || 'vert-menu-item',
    iconOpen: props.iconOpen || <Icon className="lucide color-detached txt-balance-icon" size="18px" component={LuChevronDown} />,
    iconClose: props.iconClose || <Icon className="lucide color-detached txt-balance-icon" size="18px" component={LuChevronUp} />
  };

  return (
    <VertDropdown {...attributesDropdown} />
  );
};

Dropdown.propTypes = {
  activeArrow: PropTypes.bool,
  icon: PropTypes.node,
  iconOpen: PropTypes.node,
  iconClose: PropTypes.node,
  id: PropTypes.string,
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Dropdown;
